import { PrivateRoute } from 'components/PrivateRoute'
import { CHANGE_PASSWORD_PATH, LOGIN_PATH, RESET_PASSWORD_PATH } from 'data/auth/utils'
import { appMounted } from 'duck/actions'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router'
import { ChangePassword, Login, ResetPassword } from 'scenes/Account'
import { Dashboard } from 'scenes/Dashboard'
import { DASHBOARD_PATH } from 'scenes/Dashboard/Dashboard.routes'

export function AppRoutes() {
  useAppRoutesEffects()
  return (
    <Switch>
      <Route exact path="/">
        <Redirect to={DASHBOARD_PATH} />
      </Route>
      <PrivateRoute path={DASHBOARD_PATH} component={Dashboard} />
      <Route path={LOGIN_PATH} component={Login} />
      <Route path={RESET_PASSWORD_PATH} component={ResetPassword} />
      <Route path={CHANGE_PASSWORD_PATH} component={ChangePassword} />
    </Switch>
  )
}

export function useAppRoutesEffects() {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(appMounted())
  }, [dispatch])
}
